<template>
	<div ref="el" data-component="fckn-row" class="g-row fckn-row">
		<div class="g-col xxl-24">
			<div class="left">
				<p ref="leftYear" class="-p-medium">{{ year }}</p>
				<svg
					ref="leftLogo"
					viewBox="0 0 30 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
				>
					<path
						d="M19.2891 18.624V6.07196H21.2811V8.06396C21.4731 7.66396 21.7531 7.30396 22.1211 6.98396C22.4891 6.64796 22.9371 6.37596 23.4651 6.16796C24.0091 5.95996 24.6251 5.85596 25.3131 5.85596C26.1771 5.85596 26.9371 6.02396 27.5931 6.35996C28.2651 6.69596 28.7851 7.23996 29.1531 7.99196C29.5371 8.72796 29.7291 9.70396 29.7291 10.92V18.624H27.7371V10.776C27.7371 9.67196 27.4971 8.86396 27.0171 8.35196C26.5371 7.83996 25.7931 7.58396 24.7851 7.58396C24.1771 7.58396 23.6011 7.71196 23.0571 7.96796C22.5291 8.22396 22.0971 8.60796 21.7611 9.11996C21.4411 9.63196 21.2811 10.264 21.2811 11.016V18.624H19.2891Z"
						fill="currentColor"
					/>
					<path
						d="M8.11328 18.6243V0.0722656H10.1053V18.6243H8.11328ZM15.6733 18.6243L9.96128 11.9523L15.3133 6.07227H17.6413L12.2653 11.9043L18.0973 18.6243H15.6733Z"
						fill="currentColor"
					/>
					<path
						d="M1.8 18.624V7.752H0V6.072H1.8V4.032C1.8 3.184 1.936 2.464 2.208 1.872C2.48 1.264 2.888 0.799999 3.432 0.48C3.992 0.16 4.68 0 5.496 0C5.816 0 6.072 0.0159998 6.264 0.0479994C6.472 0.0639992 6.672 0.112 6.864 0.192V1.872C6.688 1.792 6.496 1.736 6.288 1.704C6.08 1.672 5.84 1.656 5.568 1.656C5.152 1.656 4.808 1.752 4.536 1.944C4.28 2.12 4.088 2.368 3.96 2.688C3.848 3.008 3.792 3.384 3.792 3.816V6.072H6.864V7.752H3.792V18.624H1.8Z"
						fill="currentColor"
					/>
					<path
						d="M16.7391 13.6723C16.7391 16.407 14.5222 18.6239 11.7875 18.6239C9.05284 18.6239 6.83594 16.407 6.83594 13.6723C6.83594 10.9376 9.05284 8.7207 11.7875 8.7207C14.5222 8.7207 16.7391 10.9376 16.7391 13.6723Z"
						fill="black"
					/>
					<path
						d="M8.14881 17.0956H15.2373L12.7336 18.3637H11.6931H10.6526L8.14881 17.0956ZM8.96172 15.1121H9.18933L9.15681 15.421H8.89668L8.96172 15.1121ZM9.04301 16.1201H9.27062L9.33565 15.6486H9.61204V15.421H9.36817L9.41694 15.1121H9.69333V14.8682H9.46572L9.51449 14.4617H9.28688L9.22184 14.8682H8.99423L9.05926 14.4617H8.81539L8.76662 14.8682H8.49023V15.1121H8.71784L8.66907 15.421H8.40894V15.6486H8.63655L8.57152 16.1201H8.79914L8.86417 15.6486H9.10804L9.04301 16.1201ZM10.0673 15.8112H10.3111L10.3599 14.4617H10.0185L10.0673 15.8112ZM10.1811 16.3965C10.2136 16.3965 10.2515 16.3856 10.2949 16.3639C10.3382 16.3423 10.3599 16.3206 10.3599 16.2989C10.3816 16.2772 10.3924 16.2447 10.3924 16.2014C10.3924 16.158 10.3816 16.1255 10.3599 16.1038C10.3599 16.0713 10.3382 16.0442 10.2949 16.0225C10.2732 16.0117 10.2353 16.0063 10.1811 16.0063C10.1377 16.0063 10.1052 16.0117 10.0835 16.0225C10.051 16.0442 10.0239 16.0713 10.0022 16.1038C9.99139 16.1255 9.98597 16.158 9.98597 16.2014C9.98597 16.2447 9.99139 16.2772 10.0022 16.2989C10.0347 16.3314 10.0618 16.3531 10.0835 16.3639C10.1269 16.3856 10.1594 16.3965 10.1811 16.3965ZM11.8069 15.8112C11.731 15.8112 11.6768 15.7841 11.6443 15.7299C11.6009 15.6648 11.5793 15.6052 11.5793 15.551C11.5793 15.4968 11.5793 15.4535 11.5793 15.421C11.5901 15.3885 11.6009 15.3559 11.6118 15.3234C11.6443 15.2801 11.6822 15.2421 11.7256 15.2096C11.7798 15.1771 11.8286 15.1608 11.8719 15.1608C11.9369 15.1608 11.9911 15.1825 12.0345 15.2259C12.0778 15.2692 12.0995 15.3343 12.0995 15.421C12.0995 15.4968 12.0833 15.5619 12.0507 15.6161C12.0399 15.6811 12.0074 15.7245 11.9532 15.7461C11.8882 15.7895 11.8394 15.8112 11.8069 15.8112ZM11.8557 16.5428C11.9207 16.5428 11.9857 16.5428 12.0507 16.5428C12.1158 16.5319 12.1754 16.5211 12.2296 16.5103C12.2838 16.4886 12.338 16.4669 12.3922 16.4452C12.4464 16.4127 12.4951 16.3856 12.5385 16.3639C12.6252 16.2989 12.6902 16.2339 12.7336 16.1688H12.506C12.4843 16.1797 12.4572 16.1959 12.4247 16.2176C12.403 16.2285 12.3759 16.2447 12.3434 16.2664C12.3109 16.2772 12.2784 16.2935 12.2458 16.3152C12.2133 16.326 12.1754 16.3368 12.132 16.3477C12.0887 16.3585 12.0453 16.3639 12.002 16.3639C11.9586 16.3639 11.9153 16.3639 11.8719 16.3639C11.6985 16.3639 11.563 16.3423 11.4655 16.2989C11.4113 16.2772 11.3571 16.2501 11.3029 16.2176C11.2595 16.1851 11.2216 16.1472 11.1891 16.1038C11.1024 16.0388 11.0427 15.9466 11.0102 15.8274C10.9777 15.7082 10.9615 15.5944 10.9615 15.486C10.9615 15.3234 10.9831 15.1988 11.0265 15.1121C11.059 14.9928 11.124 14.8899 11.2216 14.8032C11.3083 14.7165 11.4058 14.6568 11.5142 14.6243C11.6226 14.5701 11.7527 14.543 11.9044 14.543C12.0887 14.543 12.2458 14.5756 12.3759 14.6406C12.506 14.7056 12.6035 14.7977 12.6686 14.917C12.7336 15.0254 12.7661 15.1608 12.7661 15.3234C12.7661 15.3776 12.7661 15.4318 12.7661 15.486C12.7661 15.5294 12.7553 15.5727 12.7336 15.6161C12.6902 15.7028 12.6523 15.757 12.6198 15.7786C12.5547 15.822 12.506 15.8437 12.4735 15.8437C12.4301 15.8437 12.3976 15.822 12.3759 15.7786C12.3434 15.7461 12.338 15.6974 12.3597 15.6323L12.4409 14.9657H12.1483L12.132 15.1121C12.1104 15.0579 12.0778 15.0199 12.0345 14.9983C12.002 14.9657 11.9315 14.9495 11.8231 14.9495C11.7256 14.9495 11.6389 14.9712 11.563 15.0145C11.4763 15.0904 11.4113 15.1663 11.3679 15.2421C11.3137 15.3288 11.2866 15.4318 11.2866 15.551C11.2866 15.6919 11.33 15.8057 11.4167 15.8925C11.4926 15.9683 11.5955 16.0063 11.7256 16.0063C11.8015 16.0063 11.8557 15.9954 11.8882 15.9737C11.9532 15.9521 11.9966 15.925 12.0182 15.8925C12.0399 15.8708 12.0562 15.8491 12.067 15.8274C12.0887 15.8057 12.1049 15.7895 12.1158 15.7786C12.1375 15.8545 12.17 15.9087 12.2133 15.9412C12.2784 15.9846 12.3542 16.0063 12.4409 16.0063C12.506 16.0063 12.571 15.99 12.636 15.9575C12.6686 15.9466 12.6957 15.9304 12.7173 15.9087C12.7498 15.887 12.7769 15.8654 12.7986 15.8437C12.8528 15.7895 12.8962 15.719 12.9287 15.6323C12.9612 15.5456 12.9775 15.4426 12.9775 15.3234C12.9775 15.1825 12.9504 15.0579 12.8962 14.9495C12.8528 14.8303 12.7769 14.7273 12.6686 14.6406C12.571 14.5539 12.4626 14.4834 12.3434 14.4292C12.2675 14.4076 12.1917 14.3913 12.1158 14.3805C12.0507 14.3696 11.9803 14.3642 11.9044 14.3642C11.7635 14.3642 11.6118 14.3913 11.4492 14.4455C11.3083 14.4997 11.1837 14.581 11.0753 14.6894C11.0319 14.7327 10.9831 14.7869 10.9289 14.8519C10.8856 14.9061 10.8531 14.9712 10.8314 15.047C10.7664 15.1771 10.7338 15.3234 10.7338 15.486C10.7338 15.6486 10.7609 15.7841 10.8151 15.8925C10.8693 16.0334 10.9398 16.1472 11.0265 16.2339C11.1349 16.3423 11.2541 16.4181 11.3842 16.4615C11.4492 16.494 11.5197 16.5157 11.5955 16.5265C11.6822 16.5374 11.7689 16.5428 11.8557 16.5428ZM13.8229 14.917C13.8229 14.8303 13.8446 14.7706 13.8879 14.7381C13.9313 14.6948 13.9855 14.6731 14.0505 14.6731C14.1155 14.6731 14.1643 14.6894 14.1968 14.7219C14.2293 14.7652 14.2456 14.814 14.2456 14.8682C14.2456 14.9332 14.2402 14.982 14.2293 15.0145C14.2185 15.0254 14.2022 15.0416 14.1806 15.0633C14.1697 15.0741 14.1535 15.0904 14.1318 15.1121C14.1101 15.1337 14.0559 15.1663 13.9692 15.2096C13.9584 15.1771 13.9421 15.15 13.9204 15.1283C13.8987 15.0958 13.8825 15.0687 13.8717 15.047C13.8391 15.0145 13.8229 14.9712 13.8229 14.917ZM13.9042 16.1688C13.8391 16.1688 13.7795 16.1526 13.7253 16.1201C13.6711 16.1092 13.6278 16.0713 13.5953 16.0063C13.5736 15.9737 13.5627 15.9196 13.5627 15.8437C13.5627 15.757 13.5736 15.6974 13.5953 15.6648C13.6061 15.6215 13.6386 15.5836 13.6928 15.551C13.7362 15.5077 13.7795 15.4806 13.8229 15.4697L14.2618 15.99C14.2293 16.0334 14.1968 16.0659 14.1643 16.0876C14.1535 16.0984 14.1318 16.1092 14.0993 16.1201C14.0776 16.1309 14.0559 16.1363 14.0342 16.1363C13.9909 16.158 13.9475 16.1688 13.9042 16.1688ZM14.9609 15.3885H14.6846L14.4895 15.7786L14.1155 15.3559C14.1589 15.3343 14.1968 15.3126 14.2293 15.2909C14.2727 15.2692 14.3106 15.2476 14.3431 15.2259C14.3648 15.2042 14.3919 15.1825 14.4244 15.1608C14.4569 15.1283 14.4786 15.0958 14.4895 15.0633C14.5111 15.0416 14.522 15.0145 14.522 14.982C14.522 14.9386 14.522 14.8953 14.522 14.8519C14.522 14.8194 14.5166 14.7869 14.5057 14.7544C14.5057 14.711 14.4949 14.6785 14.4732 14.6568C14.419 14.581 14.3594 14.5268 14.2944 14.4943C14.2618 14.4726 14.2239 14.4617 14.1806 14.4617C14.148 14.4617 14.1047 14.4617 14.0505 14.4617C14.0071 14.4617 13.9638 14.4617 13.9204 14.4617C13.8771 14.4617 13.8337 14.4726 13.7904 14.4943C13.7578 14.5159 13.7253 14.543 13.6928 14.5756C13.6603 14.5972 13.6278 14.6243 13.5953 14.6568C13.5519 14.7436 13.5302 14.8303 13.5302 14.917C13.5302 14.9495 13.5411 15.0091 13.5627 15.0958C13.5844 15.1283 13.6007 15.1608 13.6115 15.1934C13.6332 15.2259 13.6603 15.2638 13.6928 15.3072C13.6495 15.318 13.6061 15.3343 13.5627 15.3559C13.5302 15.3776 13.4977 15.3993 13.4652 15.421C13.3893 15.4752 13.3351 15.5402 13.3026 15.6161C13.2593 15.6703 13.2376 15.7516 13.2376 15.8599C13.2376 15.9683 13.2647 16.0659 13.3189 16.1526C13.3731 16.2176 13.4489 16.2772 13.5465 16.3314C13.6332 16.3748 13.7416 16.3965 13.8717 16.3965C13.9258 16.3965 13.9692 16.3965 14.0017 16.3965C14.0342 16.3856 14.0667 16.3748 14.0993 16.3639C14.1643 16.3531 14.2239 16.326 14.2781 16.2826C14.2998 16.261 14.3269 16.2447 14.3594 16.2339C14.3919 16.2122 14.4136 16.1905 14.4244 16.1688L14.587 16.3802H14.9772L14.6358 15.99L14.9609 15.3885ZM14.2944 10.446L14.3757 10.1696L14.2131 9.92575L13.9692 9.86071L13.2051 10.1696L12.4409 10.9175V11.1288L12.7661 11.2752L13.01 11.1776L14.2944 10.446ZM14.2131 12.5596V12.3157L14.1968 12.2832L13.9855 11.8117L13.9529 11.7792L13.514 11.5678H13.1888L12.7498 11.7792L12.7336 11.8117L12.506 12.2832L12.4897 12.3157V12.4295V12.5596L12.506 12.5921L12.7336 13.0473L12.7498 13.0798L13.1888 13.3074H13.3514H13.514L13.9529 13.0798L13.9855 13.0473L14.1968 12.5921L14.2131 12.5596ZM10.9452 11.1288V10.9175L10.1648 10.1696L9.41694 9.86071L9.15681 9.92575L9.01049 10.1696L9.09178 10.446L10.3599 11.1776L10.62 11.2752L10.9452 11.1288ZM10.8964 12.5596V12.3157L10.8802 12.2832L10.6526 11.8117L10.62 11.7792L10.1973 11.5678H9.87217L9.4332 11.7792L9.40068 11.8117L9.17307 12.2832L9.15681 12.3157V12.4295V12.5596L9.17307 12.5921L9.40068 13.0473L9.4332 13.0798L9.87217 13.3074H10.0347H10.1973L10.62 13.0798L10.6526 13.0473L10.8802 12.5921L10.8964 12.5596ZM17.172 11.7792L17.2533 12.023V13.5676L17.172 13.8114L15.7251 16.7379L15.6926 16.7704V14.2179C15.6167 14.1312 15.5517 14.0607 15.4975 14.0065C15.4433 13.9523 15.3728 13.8873 15.2861 13.8114H8.10004C7.95914 13.9415 7.82365 14.077 7.69359 14.2179V16.7704L7.64481 16.7379L6.2141 13.8114L6.13281 13.5676V12.8034V12.023L6.2141 11.7792L7.64481 8.86897L7.83991 8.65762L10.6526 7.24316H12.7336L15.5462 8.65762L15.7251 8.86897L17.172 11.7792Z"
						fill="currentColor"
					/>
				</svg>
			</div>

			<div class="preorder">
				<svg
					ref="leftHand"
					width="32"
					height="32"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="left-hand"
				>
					<path
						d="M2.1349 11.3324L12.8819 5.33337L14.0754 6.53268L14.0754 8.93379L12.8819 10.1331L28.408 10.1331L29.6016 11.3324L29.6016 13.598L28.408 14.9328L22.4378 14.9328L22.4378 17.3339L21.2442 18.5332L20.0507 18.5332L21.2442 19.7325L21.2442 22.1337L20.0507 23.333L20.0507 25.7341L18.8571 26.9334L6.9141 26.9334L2.13739 23.333L2.1349 11.6059L2.1349 11.3324Z"
						stroke="white"
						stroke-width="1.33333"
						stroke-miterlimit="10"
					/>
				</svg>

				<button ref="preorderButton" type="button" class="-p-medium" @click="handlePreorderClick">
					Pre-order
				</button>
				<svg
					ref="rightHand"
					width="32"
					height="32"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="right-hand"
				>
					<path
						d="M29.8651 11.3324L19.1181 5.33337L17.9246 6.53268L17.9246 8.93379L19.1181 10.1331L3.59199 10.1331L2.39844 11.3324L2.39844 13.598L3.59199 14.9328L9.56224 14.9328L9.56224 17.3339L10.7558 18.5332L11.9493 18.5332L10.7558 19.7325L10.7558 22.1337L11.9493 23.333L11.9493 25.7341L13.1429 26.9334L25.0859 26.9334L29.8626 23.333L29.8651 11.6059L29.8651 11.3324Z"
						stroke="white"
						stroke-width="1.33333"
						stroke-miterlimit="10"
					/>
				</svg>
			</div>
			<p ref="rightLabel" class="-p-medium year">{{ yearLabel }}</p>
		</div>
	</div>
</template>

<script setup>
import { inject, onBeforeUnmount, onMounted, ref } from 'vue'
import { createFcknRowMotion } from './FcknRow.motion'

defineProps({
	year: { type: [String, Number], default: '' },
	yearLabel: { type: String, default: '' },
})
const emit = defineEmits(['open-preorder'])

const el = ref(null)
const leftYear = ref(null)
const leftLogo = ref(null)
const preorderButton = ref(null)
const rightLabel = ref(null)
const leftHand = ref(null)
const rightHand = ref(null)
const pageProvider = inject('$page', null)

let motion = null

function handlePreorderClick() {
	emit('open-preorder')
}

onMounted(() => {
	motion = createFcknRowMotion({
		el,
		leftYear,
		leftLogo,
		preorderButton,
		rightLabel,
		leftHand,
		rightHand,
		getLoader: () => pageProvider?.pageCtx?.$page?.loader,
	})

	motion.mount()
})

onBeforeUnmount(() => {
	motion?.kill()
	motion = null
})
</script>

<style lang="scss" scoped>
[data-component='fckn-row'] {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;

	width: 100%;
	pointer-events: none;

	color: var(--color-geral-white);
	mix-blend-mode: difference;

	.g-col {
		display: flex;
		align-items: center;
		justify-content: space-between;

		padding: rs(12, 12);
	}

	.left {
		display: flex;
		align-items: center;
		gap: rs(5, 5);
		svg {
			width: rs(30, 25);
			// width: auto;
		}
	}

	.preorder {
		display: flex;
		align-items: center;
		gap: rs(10, 8);

		color: var(--color-geral-white);
		pointer-events: all;

		button {
			text-decoration: underline;
		}
	}

	svg {
		display: block;
		flex: 0 0 auto;
	}

	.left-hand,
	.right-hand {
		opacity: 0;
		visibility: hidden;
		transform-origin: center;
		will-change: transform, opacity;
	}

	svg,
	path {
		color: var(--color-geral-white);
	}

	.-p-medium {
		color: var(--color-geral-white);
	}

	.year {
		// background-color: red;
	}
}
</style>
